
<div *ngFor="let message of (messages$ | async)" class="message mat-elevation-z2">
    <div [innerHTML]="message.message"></div>
</div>
